import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Nav from "react-bootstrap/Nav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faCalendarAlt,
  faLocationArrow,
  faMobileAlt,
  faUser,
  faCheck,
  faUsers,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import useTheme from "./useTheme";

const Moshtarian = (props) => {
  const [showMoshtarian, setShowMoshtarian] = useState(false);

  const [showtakhfif, setShowTakhfif] = useState(false);

  const [showMoshtari, setShowMoshtari] = useState(false);

  const [showRemoveMoshtari, setShowRemoveMoshtari] = useState(false);

  const [showRemoveRes, setShowRemoveRes] = useState(false);

  const [showDarsadRes, setShowDarsadRes] = useState(false);

  const [showAllDastresi, setShowAllDastresi] = useState(false);

  const [moshtarianResult, setMoshtarianResult] = useState([]);

  const [searchResult, setSearchResult] = useState([]);

  const [moshtariProfile, setMoshtariProfile] = useState([]);

  const [dastresi, setDastresi] = useState([]);

  const [allDastresi, setAllDastresi] = useState("0");

  const [removeRes, setRemoveRes] = useState("");

  const [darsadRes, setDarsadRes] = useState("");

  const [search, setSearch] = useState("");

  const [darsad, setDarsad] = useState("");

  const [takhfif, setTakhfif] = useState("");

  const [theme, switchTheme] = useTheme();

  useEffect(() => {
    const form = new FormData();
    form.append("list_moshtari", 1);
    form.append("vitrinCode", props.id);

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setMoshtarianResult(data);
        console.log(data);
        const array = [];
        data.map((item) => {
          array.push(item.isNotShow);
        });
        setDastresi(array);
      });
  }, [props, showRemoveRes, showDarsadRes , showAllDastresi]);

  useEffect(() => {
    const array = moshtarianResult.filter((item) => {
      return (
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.mobile.includes(search)
      );
    });
    const dastresiArray = [];
    array.map((item) => {
      dastresiArray.push(item.isNotShow);
    });
    setDastresi(dastresiArray);
    setSearchResult(array);
  }, [search]);

  const moshtarian = () => {
    setShowMoshtarian(true);
  };

  const changeDastresi = (value, pk, index) => {
    const form = new FormData();
    form.append("change_dastresi", 1);
    form.append("pkMoshtari", pk);
    form.append("dastresi", value);
    form.append("vitrinCode" , props.id)
    // if(pk===0){
    //   console.log(props.id)
    //   return
    // }

    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data === 1 && pk === 0) {
          alert("تغییرات با موفقیت انجام شد")
        } else if (data === 1) {
          const array = [...dastresi];
          array.splice(index, 1, value);
          setDastresi(array);
        } else {
          alert("خطا در ارتباط با سرور !");
        }
      });
  };

  const removeMoshtari = () => {
    const form = new FormData();
    form.append("remove_moshtari", 1);
    form.append("mobile", moshtariProfile.mobile);
    form.append("vitrinCode", moshtariProfile.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setRemoveRes(data.data);
        setShowRemoveMoshtari(false);
        setShowRemoveRes(true);
        if (data.result) {
          setShowMoshtari(false);
        }
      })
      .catch((e) => {
        console.log(e);
        setRemoveRes("اشکال در برقراری ارتباط با سرور");
        setShowRemoveMoshtari(false);
        setShowRemoveRes(true);
      });
  };

  const showProfileMoshtari = (moshtari) => {
    setMoshtariProfile(moshtari);
    setDarsad(parseFloat(moshtari.darsad));
    setShowMoshtarian(false);
    setShowMoshtari(true);
  };

  const searchHandle = (e) => {
    setSearch(e.target.value);
  };

  const darsadHandle = (e) => {
    if (!isNaN(e.target.value)) {
      setDarsad(e.target.value);
    }
  };

  const takhfifHandle = (e) => {
    if (e.target.value.length > 4) {
      return;
    }
    if (!isNaN(e.target.value)) {
      setTakhfif(e.target.value);
    }
  };

  const changeDarsad = (isAll) => {
    if (parseFloat(darsad) > 10) {
      setDarsadRes("درصد وارد شده نامعتبر است");
      setShowDarsadRes(true);
      return;
    }
    const form = new FormData();
    form.append("change_darsad", 1);
    form.append("vitrinCode", props.id);
    form.append("pkMoshtari", !isAll ? moshtariProfile.pkMoshtari : 0);
    form.append("darsad", isAll ? parseFloat(takhfif) : parseFloat(darsad));
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          setDarsadRes("تغییرات با موفقیت انجام شد");
          setShowDarsadRes(true);
        } else {
          setDarsadRes("اشکال در برقراری ارتباط با سرور");
          setShowDarsadRes(true);
        }
      })
      .catch((e) => {
        setDarsadRes("اشکال در برقراری ارتباط با سرور");
        setShowDarsadRes(true);
      });
  };

  return (
    <div>
      <Nav.Link
        onClick={() => {
          moshtarian();
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        مشتریان {" (" + moshtarianResult.length + ")"}
      </Nav.Link>

      <Modal
        show={showMoshtarian}
        onHide={() => setShowMoshtarian(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          مشتریان {" (" + moshtarianResult.length + ")"}
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <input
            className="form-control"
            placeholder="جستجو"
            value={search}
            onChange={searchHandle}
          />
          <table
            className={
              theme === "light"
                ? "table table-striped rtl text-dark"
                : "table table-striped rtl text-light"
            }
          >
            <thead>
              <tr>
                <th scope="col">نام</th>
                <th scope="col">دسترسی</th>
                <th scope="col">درصد تخفیف</th>
              </tr>
            </thead>
            <tbody>
              {search === ""
                ? moshtarianResult.map((item, index) => (
                    <tr key={item.pkMoshtari}>
                      <td
                        onClick={() => {
                          showProfileMoshtari(item);
                        }}
                      >
                        {item.name}
                      </td>
                      <td>
                        <select
                          className="custom-select rtl"
                          value={dastresi[index]}
                          onChange={(e) => {
                            changeDastresi(
                              e.target.value,
                              item.pkMoshtari,
                              index
                            );
                          }}
                        >
                          <option value={"0"}>خرده فروشی</option>
                          <option value={"1"}>خرده فروشی خصوصی</option>
                          <option value={"2"}>عمده</option>
                          <option value={"3"}>عمده خصوصی</option>
                          <option value={"4"}>بدون قیمت</option>
                          <option value={"5"}>بدون قیمت خصوصی</option>
                        </select>
                      </td>
                      <td>{parseFloat(item.darsad)}</td>
                    </tr>
                  ))
                : searchResult.map((item, index) => (
                    <tr key={item.pkMoshtari}>
                      <td
                        onClick={() => {
                          showProfileMoshtari(item);
                        }}
                      >
                        {item.name}
                      </td>
                      <td>
                        <select
                          className="custom-select rtl"
                          value={dastresi[index]}
                          onChange={(e) => {
                            changeDastresi(
                              e.target.value,
                              item.pkMoshtari,
                              index
                            );
                          }}
                        >
                          <option value={"0"}>خرده فروشی</option>
                          <option value={"1"}>خرده فروشی خصوصی</option>
                          <option value={"2"}>عمده</option>
                          <option value={"3"}>عمده خصوصی</option>
                          <option value={"4"}>بدون قیمت</option>
                          <option value={"5"}>بدون قیمت خصوصی</option>
                        </select>
                      </td>
                      <td>{parseFloat(item.darsad)}</td>
                    </tr>
                  ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => setShowMoshtarian(false)}
          >
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              setShowAllDastresi(true);
              setShowMoshtarian(false);
            }}
          >
            تغییر دسترسی همه
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              setShowTakhfif(true);
              setShowMoshtarian(false);
            }}
          >
            تخفیف برای همه
          </button>
        </Modal.Footer>
      </Modal>

      {/*---------------AllTakhfif-----------*/}
      <Modal
        show={showAllDastresi}
        onHide={() => {
          setShowAllDastresi(false);
          setShowMoshtarian(true);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          تغییر دسترسی همه مشتریان
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="text-center mx-3">
            <select
              className="custom-select rtl"
              value={allDastresi}
              onChange={(e) => {
                setAllDastresi(e.target.value);
              }}
            >
              <option value={"0"}>خرده فروشی</option>
              <option value={"1"}>خرده فروشی خصوصی</option>
              <option value={"2"}>عمده</option>
              <option value={"3"}>عمده خصوصی</option>
              <option value={"4"}>بدون قیمت</option>
              <option value={"5"}>بدون قیمت خصوصی</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowAllDastresi(false);
              setShowMoshtarian(true);
            }}
          >
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              changeDastresi(allDastresi, 0, 0);
            }}
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
      {/*---------------takhfif-----------*/}
      <Modal
        show={showtakhfif}
        onHide={() => {
          setShowTakhfif(false);
          setShowMoshtarian(true);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          تخفیف برای همه مشتریان
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="text-center mx-3">
            <input
              className="form-control"
              type="number"
              value={takhfif}
              maxLength="4"
              onChange={takhfifHandle}
            />
          </div>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowTakhfif(false);
              setShowMoshtarian(true);
            }}
          >
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              changeDarsad(true);
            }}
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>

      {/*---------------moshtarian-----------*/}
      <Modal
        show={showMoshtari}
        onHide={() => {
          setShowMoshtari(false);
          setShowMoshtarian(true);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          پروفایل مشتری
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="row rtl">
            <div className="col-12 mb-4 text-center">
              {moshtariProfile.image === "" ? (
                <>
                  <FontAwesomeIcon icon={faUserCircle} size="5x" />
                </>
              ) : (
                <img
                  className="image rounded-circle"
                  src={moshtariProfile.image}
                />
              )}
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                <FontAwesomeIcon icon={faUser} />
                {" نام مشتری : " + moshtariProfile.name}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                <FontAwesomeIcon icon={faMobileAlt} />
                {" تلفن همراه :" + moshtariProfile.mobile}
              </div>
            </div>
            {moshtariProfile.work !== "" && moshtariProfile.work !== null ? (
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="profile-item">
                  <FontAwesomeIcon icon={faBriefcase} />
                  {" زمینه فعالیت :" + moshtariProfile.work}
                </div>
              </div>
            ) : null}
            {moshtariProfile.address !== "" &&
            moshtariProfile.address !== null ? (
              <div className="col-lg-4 col-md-6 mb-4">
                <div className="profile-item">
                  <FontAwesomeIcon icon={faLocationArrow} />
                  {" آدرس : " + moshtariProfile.address}
                </div>
              </div>
            ) : null}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                <FontAwesomeIcon icon={faCalendarAlt} />
                {" تاریخ عضویت :" + moshtariProfile.tarikh}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="profile-item">
                <FontAwesomeIcon icon={faUsers} />
                {" تعداد معرفی ها : " + moshtariProfile.moaref}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="row mx-2">
                <div className="col-9 pt-1">تخفیف ویژه مشتری</div>
                <input
                  className="form-control col-3"
                  value={darsad}
                  maxLength="4"
                  onChange={darsadHandle}
                />
                {/* <div className="col-2">
                  <button className="btn btn-success" onClick={changeDarsad}>
                    <FontAwesomeIcon icon={faCheck} />
                  </button>
                </div> */}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <button
                className="btn btn-danger"
                onClick={() => setShowRemoveMoshtari(true)}
              >
                حذف کاربر
              </button>
            </div>
            {moshtariProfile.sefareshat !== undefined &&
            moshtariProfile.sefareshat !== null ? (
              <div className="col-lg-12 col-md-12 mb-4">
                <table className="table profile-item">
                  <thead>
                    <tr>
                      <th colSpan="4">سفارشات</th>
                    </tr>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">نام کالا</th>
                      <th scope="col">وزن</th>
                      <th scope="col">تعداد</th>
                    </tr>
                  </thead>
                  <tbody>
                    {moshtariProfile.sefareshat.map((item, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>{item.kalaName}</td>
                        <td>{item.vazn !== "" ? item.vazn : 0}</td>
                        <td>{item.tedad !== "" ? item.tedad : 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="col-lg-12 col-md-12 mb-4">
                <p className="profile-item">این کاربر سفارشی ثبت نکرده است</p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowMoshtari(false);
              setShowMoshtarian(true);
            }}
          >
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => changeDarsad(false)}
          >
            ثبت تغییرات
          </button>
          {/* <button
            className="btn btn-danger"
            onClick={() => {
              setShowRemoveMoshtari(true);
            }}
          >
            حذف کاربر
          </button> */}
        </Modal.Footer>
      </Modal>

      {/*---------------change_darsad_result-----------*/}
      <Modal
        show={showDarsadRes}
        onHide={() => {
          setShowDarsadRes(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <p className="text-center">{darsadRes}</p>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowDarsadRes(false);
              setDarsadRes("");
              setShowTakhfif(false);
              setShowMoshtari(false);
              setShowMoshtarian(true);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      {/*---------------remove_moshtarian-----------*/}
      <Modal
        show={showRemoveMoshtari}
        onHide={() => {
          setShowRemoveMoshtari(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          حذف مشتری
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <p className="text-center">
            {"از حذف مشتری ( " + moshtariProfile.name + ") اطمینان دارید؟"}
          </p>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-danger"
            onClick={() => {
              setShowRemoveMoshtari(false);
            }}
          >
            بستن
          </button>
          <button
            className="btn btn-success"
            onClick={() => {
              removeMoshtari();
            }}
          >
            بله
          </button>
        </Modal.Footer>
      </Modal>

      {/*---------------remove_moshtarian_result-----------*/}
      <Modal
        show={showRemoveRes}
        onHide={() => {
          setShowRemoveMoshtari(false);
          setShowRemoveRes(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <p className="text-center">{removeRes}</p>
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowRemoveMoshtari(false);
              setShowRemoveRes(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Moshtarian;
